module.exports = "/_next/static/images/967f28b5f5279dea82938d41ccc92bc9-mgm-lg-2.png.webp";